<!--
 * @Author: FengXiao
 * @Date: 2020-07-02 15:09:14
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-09 00:12:20
-->
<template>
  <div class="tab-speech-page page-container">
    <div class="banner-bl">
      <div class="banner-content">
        <span class="banner-title">一席演讲</span>
        <span class="total_numbers-wrap" v-if="totalNumber">
          <span class="total_numbers">{{ totalNumber }} +</span> 个精彩演讲视频
        </span>
      </div>
    </div>
    <div class="albums-bl content">
      <div class="albums-bl-title-wrap">
        <span class="albums-bl-title">专辑</span>
        <span class="more_btn" @click="gotoMoreAlbums">更多</span>
      </div>
      <div class="albums">
        <div class="album-item" v-for="item in albums" :key="item.id" @click="openAlbum(item)">
          <div class="album_cover">
            <img class="album_cover-img" :src="item.cover" alt="" srcset="" />
            <div class="shadow"></div>
          </div>
          <div class="album_info">
            <span class="album_title">{{ item.title }}</span>
            <span class="album_numbers">{{ item.count }}个演讲</span>
          </div>
        </div>
      </div>
    </div>
    <div class="tabs-bl content">
      <el-tabs class="tabs" v-model="activeTab" @tab-click="onClickType">
        <el-tab-pane label="全部" name="all"></el-tab-pane>
        <el-tab-pane :label="tab.title" :name="`${tab.id}`" v-for="tab in tabs" :key="tab.id"></el-tab-pane>
        <el-tab-pane name="more">
          <span slot="label">
            <el-popover placement="top-start" width="300" trigger="hover" popper-class="category-more_tabs-popover">
              <div class="more-types-bl">
                <div
                  class="tab-item"
                  :class="{ active: activeTab === item.id }"
                  v-for="item in moreTabs"
                  :key="item.id"
                  @click="onClickMoreTab(item.id)"
                >
                  {{ item.title }}
                </div>
              </div>
              <span slot="reference"> 更多 </span>
            </el-popover>
          </span>
        </el-tab-pane>
      </el-tabs>
      <div class="sort-tabs">
        <div class="tab-item" :class="{ active: activeSortTab === 1 }" @click="onClickSort(1)">
          <span class="tab-content">按发布时间排序<i class="iconfont iconarrow" :class="{ isUp: sortTabStatus[1] }"></i></span>
        </div>
        <div class="tab-item" :class="{ active: activeSortTab === 2 }" @click="onClickSort(2)">
          <span slot="label" class="tab-content">按播放量排序<i class="iconfont iconarrow" :class="{ isUp: sortTabStatus[2] }"></i></span>
        </div>
        <div class="tab-bottom-active-line" :class="[activeSortTab === 1 ? 'left' : 'right']"></div>
      </div>
    </div>
    <div class="content">
      <div class="speeches" @click="onClickSpeechItem">
        <div class="speech-item" v-for="item in speeches" :key="item.id" :data-id="item.id">
          <div class="cover-wrap no-pointer-evts">
            <img :src="item.cover" :alt="item.title" />
            <div class="video_time">{{ item.time }}</div>
          </div>
          <div class="video_intro-wrap no-pointer-evts">
            <div class="video_title">{{ item.title }}</div>
            <div class="speaker_intro-wrap">
              <span class="speaker_name">{{ item.speaker.name }}</span>
              <span class="speaker_intro">{{ item.speaker.intro }}</span>
            </div>
            <div class="video_intro">
              {{ item.titlelanguage }}
            </div>
          </div>
        </div>
      </div>
      <div class="load_more_btn" v-show="!isLoadedAll" @click="loadMore">加载更多</div>
    </div>
  </div>
</template>

<script>
import { Tabs, TabPane, Popover } from 'element-ui';
import requestApi from '@/service';

const CATEGORY_SHOW_NUMBER = 8;
const ALBUM_PAGE_SIZE = 4;

export default {
  name: 'Speech',
  components: {
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Popover.name]: Popover,
  },
  data() {
    return {
      totalNumber: 0,
      pageNum: 1,
      pageSize: 8,
      albums: [],
      activeTab: 'all',
      tabs: [],
      moreTabs: [], // tab 更多
      // 排序tab
      activeSortTab: 1,
      sortTabStatus: {
        1: false,
        2: false,
      },
      speeches: [], // 演讲数据
      total: 0,
    };
  },
  created() {
    this.getCategorys();
    this.getTotalNumber();
  },
  mounted() {
    this.init();
    this.getAlbums();
    this.refreshData();
  },
  computed: {
    isLoadedAll() {
      return this.total / this.pageSize <= this.pageNum;
    },
  },
  methods: {
    init() {
      this.activeSortTab = 1;
      this.activeTab = 'all';
    },
    /**
     * @description: 获取演讲总数
     */
    getTotalNumber() {
      requestApi('/v3/api/site/speech/total/').then(res => {
        this.totalNumber = res.total;
      });
    },
    getCategorys() {
      requestApi('/v3/api/site/category/').then(res => {
        if (res.items && res.items.length) {
          this.tabs = res.items.slice(0, CATEGORY_SHOW_NUMBER);
          this.moreTabs = res.items.slice(CATEGORY_SHOW_NUMBER);
        }
      });
    },
    /**
     * @description: 获取专辑
     */
    getAlbums() {
      requestApi('/v3/api/site/album/', {
        page: this.pageNum,
        page_size: ALBUM_PAGE_SIZE,
      }).then(res => {
        this.albums = res.items;
      });
    },
    /**
     * @description: 更多专辑
     */
    gotoMoreAlbums() {
      this.$router.push('/speech/albums');
    },
    onClickType(e) {
      if (e.name !== 'more') {
        this.refreshData();
      }
    },
    /**
     * @description: 更多内选项
     */
    onClickMoreTab(id) {
      this.activeTab = id;
      this.refreshData();
    },
    onClickSort(val) {
      if (this.activeSortTab === val) {
        if (this.sortClickTimer) {
          return;
        }
        this.sortTabStatus[val] = !this.sortTabStatus[val];
        this.sortClickTimer = setTimeout(() => {
          this.sortClickTimer = null;
        }, 500);
      } else {
        this.activeSortTab = val;
      }
      this.refreshData();
    },
    /**
     * @description: 0发布时间倒序 1发布时间正序 2播放量倒序 3播放量正序
     * @param {type}
     * @return {type}
     */
    getSort() {
      let res = 0;
      if (this.activeSortTab === 1) {
        res = this.sortTabStatus[this.activeSortTab] ? 1 : 0;
      } else if (this.activeSortTab === 2) {
        res = this.sortTabStatus[this.activeSortTab] ? 3 : 2;
      }
      return res;
    },
    /**
     * @description: 获取演讲列表
     */
    getData() {
      requestApi('/v3/api/site/speech/', {
        page: this.pageNum,
        page_size: this.pageSize,
        category_id: this.activeTab === 'all' ? '' : +this.activeTab,
        order_by: this.getSort(),
      }).then(res => {
        if (this.pageNum === 1) {
          this.speeches = res.items;
          this.total = res.total;
        } else {
          this.speeches = this.speeches.concat(res.items);
        }
      });
    },
    refreshData() {
      this.pageNum = 1;
      this.getData();
    },
    loadMore() {
      if (!this.isLoadedAll) {
        this.pageNum += 1;
        this.getData();
      }
    },
    /**
     * @description: 打开专辑
     * @param {type}
     * @return:
     */
    openAlbum(item) {
      this.$router.push({
        path: '/speech/album/detail',
        query: {
          id: item.id,
        },
      });
    },
    /**
     * @description: 事件委托 演讲点击
     */
    onClickSpeechItem(e) {
      this.$router.push({
        path: '/speech/detail',
        query: {
          id: e.target.dataset.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-speech-page {
  background: $C10;
}
.banner-bl {
  height: 260px;
  width: 100%;
  background: url('../assets/imgs/speech-bg.jpg') no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;
  box-sizing: border-box;
  .banner-content {
    width: 80%;
    height: 100%;
    margin: 0 auto;
    max-width: 1140px;
    color: $C1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .banner-title {
      font-size: 47px;
      margin: 0;
      line-height: 1.5;
      letter-spacing: 3px;
      font-family: HYXinRenWenSongW;
    }
    .total_numbers-wrap {
      font-size: 16px;
      line-height: 1.5;
      font-weight: 300;
      letter-spacing: 2px;
      .total_numbers {
        padding: 3px 10px;
        color: $C1;
        background: $C2;
        font-size: 18px;
        letter-spacing: 0.32px;
        font-weight: 400;
      }
    }
  }
}
.albums-bl {
  margin: 40px auto 0;
  &-title-wrap {
    padding: 22px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .albums-bl-title {
      font-size: 22px;
      font-weight: 400;
      font-family: HYXinRenWenSongW;
    }
    .more_btn {
      font-size: 12px;
      color: #000;
      font-weight: 300;
      margin-right: 5px;
      margin-top: 10px;
      cursor: pointer;
      &:hover {
        color: $C7;
      }
    }
  }
  .albums {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, 25%);
    grid-column-gap: 20px;
    .album-item {
      position: relative;
      box-sizing: border-box;
      max-width: 214px;
      height: 290px;
      overflow: hidden;
      border-radius: 3px;
      transition: box-shadow 0.4s linear;
      cursor: pointer;
      &:hover {
        box-shadow: 0 0 20px $A1;
      }
      .album_cover {
        position: relative;
        height: 100%;
        width: 100%;
      }
      .album_info {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        color: $C1;
        padding: 20px;
        box-sizing: border-box;
        z-index: 10;
        .album_title {
          display: block;
          padding: 5px 0;
          font-size: 17px;
          line-height: 1.4;
          font-weight: bold;
          font-family: HYXinRenWenSongW;
        }
        .album_numbers {
          display: block;
          font-size: 12px;
        }
      }
    }
  }
}
.tabs-bl {
  box-sizing: border-box;
  text-align: center;
  margin: 25px auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e7e7e7;
}
.el-tabs.tabs {
  display: inline-block;
  ::v-deep.el-tabs__item {
    font-size: 16px;
    font-weight: 200;
    color: $C3;
    transition: all 0.3s ease;
    height: 42px;
  }
  ::v-deep.el-tabs__header {
    margin: 0;
  }
  ::v-deep.el-tabs__active-bar {
    background-color: $C2;
  }
  ::v-deep.el-tabs__item.is-active {
    font-weight: 500;
  }
  ::v-deep.el-tabs__item.is-active,
  ::v-deep.el-tabs__item:hover {
    color: $C2;
  }
  ::v-deep.el-tabs__item:nth-child(2):hover::after {
    left: 0;
    transform: translateX(0%);
  }
  ::v-deep.el-tabs__item:last-child:hover::after {
    right: 0;
    left: unset;
    transform: translateX(0%);
  }
  ::v-deep.el-tabs__item:hover::after {
    content: ' ';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 32px;
    height: 2px;
    background-color: $C2;
    transition: all 0.3s ease;
  }
  ::v-deep.el-tabs__nav-wrap::after {
    content: none;
  }
}
.sort-tabs {
  flex: 1;
  margin-left: 50px;
  display: inline-flex;
  align-items: center;
  position: relative;
  .tab-item {
    flex: 1;
    font-size: 12px;
    cursor: pointer;
    color: $C9;
    position: relative;
    user-select: none;
    .iconfont {
      color: $C3;
      position: absolute;
      right: 15px;
      display: inline-block;
      transition: transform 0.3s ease-out;
      &.isUp {
        transform: rotate(-180deg);
      }
    }
    &:hover,
    &.active {
      color: $C7;
    }
  }
  .tab-bottom-active-line {
    position: absolute;
    bottom: -12px;
    width: 32px;
    height: 2px;
    background-color: $C7;
    transform: translateX(-50%);
    transition: left 0.3s ease;
    &.left {
      left: 25%;
    }
    &.right {
      left: 75%;
    }
  }
}
.speeches {
  margin: -10px;
  .speech-item {
    position: relative;
    display: inline-block;
    vertical-align: bottom;
    width: calc(25% - 20px);
    height: 256px;
    max-height: 256px;
    max-width: 270px;
    overflow: hidden;
    margin: 10px;
    background-color: $C9;
    cursor: pointer;
    .cover-wrap {
      height: 160px;
      width: 100%;
      overflow: hidden;
      position: relative;
      & > img {
        width: 100%;
        height: 100%;
        vertical-align: bottom;
        object-fit: cover;
      }
      .video_time {
        color: $C1;
        font-size: 12px;
        background: $A1;
        width: 56px;
        height: 25px;
        text-align: center;
        line-height: 25px;
        position: absolute;
        bottom: 10px;
        right: 10px;
        font-weight: 100;
      }
    }
    .video_intro-wrap {
      width: 100%;
      height: 96px;
      background-color: $C1;
      padding: 20px;
      box-sizing: border-box;
      overflow: hidden;
      position: absolute;
      bottom: 0;
      left: 0;
      transition: height 0.3s ease-out;
      .video_title {
        color: $C6;
        font-size: 16px;
        line-height: 17px;
        font-family: HYXinRenWenSongW;
      }
      .speaker_intro-wrap {
        font-size: 12px;
        margin: 10px auto 2px;
        font-weight: 200;
        color: $C4;
        line-height: 12px;
        .speaker_name {
          margin-right: 10px;
        }
      }
      .video_intro {
        margin-top: 18px;
        font-size: 14px;
        color: $C6;
        line-height: 21px;
        font-weight: 300;
        font-family: 'PingFangSC-Light';
        opacity: 0;
        max-height: 128px;
        overflow: hidden;
      }
      .speaker_intro-wrap .speaker_intro,
      .video_intro {
        opacity: 0;
        transition: opacity 0.3s ease;
      }
    }
    &:hover {
      .video_intro-wrap {
        height: 100%;
        .speaker_intro-wrap {
          color: $C7;
          font-weight: 400;
        }
        .speaker_intro,
        .video_intro {
          opacity: 1;
        }
      }
    }
  }
}
.more-types-bl {
  display: grid;
  grid-template-columns: repeat(4, 25%);
  text-align: center;
  color: $C6;
  font-size: 16px;
  .tab-item {
    padding: 15px 0;
    position: relative;
    cursor: pointer;
    &:hover {
      color: $C2;
    }
    &.active::after,
    &:hover::after {
      content: ' ';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 32px;
      height: 2px;
      background-color: $C2;
      transition: all 0.3s ease;
    }
  }
}
</style>
<style lang="scss">
.category-more_tabs-popover {
  background: $C1;
}
</style>
